'use client'

import { GiftCards } from '@/screens/GiftCard'

const GiftsPageContent = () => {
	return <GiftCards />
}

export function GiftsClient() {
	return <GiftsPageContent />
}
